import React, { useState, useEffect } from 'react';
import { FaArrowUp } from 'react-icons/fa'; // Icono para el botón
import { dataCy, SELECTORS } from '../utils/dataCy';

const ScrollToTopButton = () => {
    const [isVisible, setIsVisible] = useState(false);

    // Detectar el scroll y mostrar/ocultar el botón
    useEffect(() => {
        const toggleVisibility = () => {
            if (window.scrollY > 300) {
                setIsVisible(true);
            } else {
                setIsVisible(false);
            }
        };

        window.addEventListener('scroll', toggleVisibility);
        return () => window.removeEventListener('scroll', toggleVisibility);
    }, []);

    // Función para desplazarse al inicio
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };

    return (
        <button
            onClick={scrollToTop}
            className={`${isVisible ? 'block' : 'hidden'
                } fixed w-14 h-14 bottom-24 right-6 bg-greenExcent text-white rounded-full shadow-lg hover:bg-green-700 transition-all duration-300 z-50 lg:hidden flex items-center justify-center`}
            aria-label="Scroll to top"
            data-cy={dataCy(SELECTORS.BUTTON, 'scroll-to-top')}
        >
            <FaArrowUp />
        </button>

    );
};

export default ScrollToTopButton;
